import PropTypes from "prop-types";
import React from "react";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";

const CountdownRenderer = ({ number, unit }) =>
  <div className="countdown__group">
    <div className="countdown__number">
      {number}
    </div>
    <div className="countdown__unit">
      {unit}
    </div>
  </div>;

CountdownRenderer.propTypes = {
  number: PropTypes.node,
  unit: PropTypes.string,
};

const Countdown = ({ days, hours, minutes, seconds, intl }) =>
  <div className="countdown">
    <CountdownRenderer
      number={days}
      unit={intl.formatMessage(messages.daysTextDescription)}
    />
    <CountdownRenderer
      number={hours}
      unit={intl.formatMessage(messages.hoursTextDescription)}
    />
    <CountdownRenderer
      number={minutes}
      unit={intl.formatMessage(messages.minutesTextDescription)}
    />
    <CountdownRenderer
      number={seconds}
      unit={intl.formatMessage(messages.secondsTextDescription)}
    />
  </div>;

Countdown.propTypes = {
  days: PropTypes.number,
  hours: PropTypes.number,
  minutes: PropTypes.number,
  seconds: PropTypes.number,
  intl: intlShape.isRequired,
};

export default injectIntl(Countdown);



// WEBPACK FOOTER //
// ./components/dashboard/Countdown.js